import { useState } from "react";

export function useRequest(requestFn: (...args: any) => Promise<any>) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<any>(null);
  const [result, setResult] = useState<any>(null);

  function execute(...args: any) {
    console.log("args: ", args);
    // eslint-disable-next-line prefer-rest-params
    console.log("arguments", arguments);

    setLoading(true);
    return requestFn(...args)
      .then((res) => {
        if (res) {
          if (res.code === 0) {
            setResult(res);
            return res;
          } else {
            throw res;
          }
        }
      })
      .catch((err) => {
        setError(err);
        throw err;
      })
      .finally(() => {
        setLoading(false);
      });
  }

  function clearRequestResult() {
    setError(null);
    setResult(null);
  }

  return {
    execute,
    loading,
    error,
    result,
    clearRequestResult,
  };
}
